module.exports = __webpack_public_path__ + "static/media/2DGACM11.1ef990b7.jpg";